module.exports = __webpack_public_path__ + "media/images/icons/lightbulb-80f25edf33f55b7d58497f4f6a3dc22a.png";